import {
  Container,
  Title,
  Accordion,
  AccordionItem,
  AccordionControl,
  AccordionPanel,
} from "@mantine/core";
import classes from "./Faq.module.css";
import mixpanel from "mixpanel-browser";
import { Link } from "wouter";

function TrackingAccordionItem({ children, value, ...props }) {
  return (
    <AccordionItem
      className={classes.item}
      onClick={() => {
        mixpanel.track("faq", { value });
      }}
      value={value}
      {...props}
    >
      {children}
    </AccordionItem>
  );
}
export default function Faq() {
  return (
    <Container size="sm" className={classes.wrapper}>
      <Title ta="center" className={classes.title}>
        FAQ
      </Title>

      <Accordion variant="separated">
        <TrackingAccordionItem value="payment">
          <AccordionControl>How can I pay?</AccordionControl>
          <AccordionPanel>
            We support payment through the usual channels such as credit card
            via Stripe. Depending on your location, additional payment methods
            might be available.
          </AccordionPanel>
        </TrackingAccordionItem>

        <TrackingAccordionItem value="subscription-required">
          <AccordionControl>
            Do I need to create a subscription?
          </AccordionControl>
          <AccordionPanel>
            No, you can simply{" "}
            <Link to="/credits">buy SKUs on a one-time basis</Link>. No
            subscription.
          </AccordionPanel>
        </TrackingAccordionItem>

        {/* <TrackingAccordionItem value="subscription-benefits">
          <AccordionControl>
            What are the benefits of a subscription?
          </AccordionControl>
          <AccordionPanel>
            Subscription credit prices are lower than one-time purchases.
          </AccordionPanel>
        </TrackingAccordionItem> */}

        <TrackingAccordionItem value="subscription-benefits">
          <AccordionControl>
            My payment was rejected or failed, what can I do?
          </AccordionControl>
          <AccordionPanel>
            In general, you can try a different payment method, like a different
            card or a different payment provider. The total amount can also play
            a role, especially if it's a large amount. Try buying a smaller
            tranche in this case. Alternatively, you can contact us at{" "}
            <a href="mailto:support@optivise.io">support@optivise.io</a>
            and we might find an alternative payment option.
          </AccordionPanel>
        </TrackingAccordionItem>

        {/* <TrackingAccordionItem value="single-month">
          <AccordionControl>
            Can I subscribe just for a single month?
          </AccordionControl>
          <AccordionPanel>
            Sure! You can subscribe for a single month and cancel at any time.
            Your access will then end at the end of the current payment period.
            <br />
            <br />
            However, it's then easier to just buy{" "}
            <Link to="/payment/prepaid">a one-time package of credits</Link>.
          </AccordionPanel>
        </TrackingAccordionItem> */}

        {/* <TrackingAccordionItem value="cancellation">
          <AccordionControl>How can I cancel my subscription?</AccordionControl>
          <AccordionPanel>
            You can cancel your subscription at any time. Just go to your
            profile page, choose "Manage Subcription" and cancel your plan. Your
            plan will then end at the end of the current payment period.
          </AccordionPanel>
        </TrackingAccordionItem> */}

        <TrackingAccordionItem value="refund">
          <AccordionControl>
            Can I get a refund of the credits I haven't used?
          </AccordionControl>
          <AccordionPanel>
            Unfortunately, that is not possible because of the overhead involved
            in that and the fees we have to pay for the payment provider.
          </AccordionPanel>
        </TrackingAccordionItem>

        <TrackingAccordionItem value="price">
          <AccordionControl>What does Optivise cost?</AccordionControl>
          <AccordionPanel>
            Please refer to the <a href="#pricing">pricing table</a>.
          </AccordionPanel>
        </TrackingAccordionItem>
      </Accordion>
    </Container>
  );
}
